import type { AudioManifest, VocabularyPayload, WordEntry } from '../types';

let vocabularyPromise: Promise<VocabularyPayload> | undefined;
let audioManifestPromise: Promise<AudioManifest> | undefined;

export function validateVocabularyPayload(value: unknown): VocabularyPayload {
  const payload = value as Partial<VocabularyPayload>;
  if (payload.schemaVersion !== 1
    || payload.count !== 5523
    || !Array.isArray(payload.words)
    || payload.words.length !== 5523) {
    throw new Error('词库版本或数量不正确');
  }
  for (let index = 0; index < payload.words.length; index += 1) {
    const word = payload.words[index];
    if (word.sourceIndex !== index + 1 || word.id !== index + 1 || !word.word || !word.ipa || !word.coreMeaning) {
      throw new Error(`词库第 ${index + 1} 条记录不完整`);
    }
  }
  return payload as VocabularyPayload;
}

export function loadVocabulary(): Promise<VocabularyPayload> {
  vocabularyPromise ??= fetch('/data/words.json').then(async (response) => {
    if (!response.ok) throw new Error('词库加载失败');
    return validateVocabularyPayload(await response.json());
  });
  return vocabularyPromise;
}

export function loadAudioManifest(): Promise<AudioManifest> {
  audioManifestPromise ??= fetch('/data/audio-manifest.json').then(async (response) => {
    if (!response.ok) throw new Error('音频清单加载失败');
    return (await response.json()) as AudioManifest;
  });
  return audioManifestPromise;
}

export async function getWord(wordId: number): Promise<WordEntry | undefined> {
  const payload = await loadVocabulary();
  return payload.words[wordId - 1];
}
